export const militaryHearingLossFAQs = [
    {
        question: 'What is Noise-Induced Hearing Loss (NIHL)?',
        answer: "Noise-Induced Hearing Loss (NIHL) is permanent hearing damage caused by prolonged exposure to loud noise without adequate protection. In military service, this commonly results from gunfire, explosions, heavy machinery operation, aircraft noise, and live fire exercises. NIHL typically affects the inner ear and can lead to permanent hearing damage.",
    },
    {
        question: 'What are the symptoms of military hearing loss?',
        answer: [
            'Ringing or buzzing in the ears (tinnitus)',
            'Difficulty understanding speech, especially in noisy environments',
            'Muffled or dulled hearing',
            'Sensitivity to certain sounds',
            'Permanent hearing loss that worsens over time',
        ],
    },
    {
        question: 'Am I eligible to make a military hearing loss claim?',
        answer: [
            'Served in the UK Armed Forces (Army, Navy, RAF, Army Reserves, or Gurkhas)',
            'Served at least partially after 1987',
            'Suffer from hearing loss or tinnitus',
            'Were not provided with adequate hearing protection during service',
        ],
    },
    {
        question: 'Why is 1987 significant for military hearing loss claims?',
        answer: "Crown Immunity protected the Ministry of Defence from liability for injuries sustained by servicemen and women before 1987. To make a civil claim, at least part of your service must have occurred after this date. For example, if you served from 1986 to 1995, you could claim for the period from 1987 onwards.",
    },
    {
        question: 'How much compensation could I receive?',
        answer: "Compensation varies significantly based on individual circumstances. Historical settlements have ranged from approximately £4,500 for straightforward cases to over £60,000 for complex cases with severe hearing loss. The final amount depends on the severity of your condition, impact on your life, and specific circumstances of your case.",
    },
    {
        question: 'How long does a military hearing loss claim take?',
        answer: "Most claims are resolved within 9 to 18 months, though more complex cases may take longer. Cases that proceed to litigation may take 2-3 years to fully resolve, though out-of-court settlements can shorten this timeframe.",
    },
    {
        question: 'What is the Armed Forces Compensation Scheme (AFCS)?',
        answer: "The AFCS provides one-time payments to military personnel for service-related injuries. However, these payments often don't cover the full extent of losses. Even if you've already claimed through AFCS or had an AFCS claim rejected, you can still pursue a separate civil claim for negligence against the Ministry of Defence.",
    },
    {
        question: "Can I claim if I've already received a War Pension or AFCS payment?",
        answer: "Yes. Receiving a War Pension or Armed Forces Independence Payment does not prevent you from making a civil claim for negligence. These are separate processes, and one does not affect the other.",
    },
    {
        question: 'Do I need to have left the military to make a claim?',
        answer: "No. You can make a claim while still in active service or as a reservist. Making a claim should not negatively impact your current employment or relationship with your employer, and it would be unlawful for them to penalize you for pursuing a legitimate claim.",
    },
    {
        question: 'Will making a claim affect my military pension or benefits?',
        answer: "No. Pursuing a civil claim for hearing loss will not impact your military pension or any other benefits you currently receive.",
    },
    {
        question: 'Will claiming affect my future employment prospects?',
        answer: "If you have the physical capability to fulfill job requirements, making a claim should not hinder your future employment prospects. Your claim remains confidential unless you choose to disclose it publicly.",
    },
    {
        question: 'What did the Ministry of Defence fail to do?',
        answer: [
            'Limiting unnecessary noise exposure',
            'Providing adequate hearing protection PPE during exercises',
            'Conducting risk assessments for planned exercises',
            'Routine monitoring and enforcement of PPE usage',
            'Responding appropriately to complaints',
        ],
    },
    {
        question: 'Do I need to attend a medical examination?',
        answer: "Yes, at least one medical assessment is required to support your claim. This is typically a straightforward process lasting less than an hour, and appointments are usually arranged close to your location for convenience.",
    },
    {
        question: 'What are the legal fees for making a claim?',
        answer: 'Most military hearing loss claims operate under a "No Win, No Fee" agreement (Conditional Fee Agreement). If your claim is successful, 25% of your compensation (including VAT) plus an insurance premium will be deducted from your final award. If your claim is unsuccessful, you won\'t pay anything unless you\'ve been materially deceptive during the process.',
    },
    {
        question: 'Is there any financial risk in making a claim?',
        answer: "No. Claims are covered by After-The-Event (ATE) insurance, which covers all legal costs if your claim is unsuccessful. You will only pay legal fees from your compensation if you win, and you won't be liable for costs if you lose (provided you've been honest throughout the process).",
    },
    {
        question: 'Will I need to go to court?',
        answer: "Most claims are settled out of court. However, if your case proceeds to litigation, you may need to attend court. Your legal representative will accompany you throughout the process and prepare you fully. Many claimants find the process more straightforward than anticipated.",
    },
    {
        question: 'Can I still claim if I was medically discharged for a different injury?',
        answer: "Yes. A medical discharge for another injury shouldn't prevent you from claiming for hearing loss, though the circumstances may affect the duration or amount of compensation. Each case is evaluated on its individual merits.",
    },
    {
        question: 'Can I claim if I no longer live in the UK?',
        answer: "Yes. As long as part of your service was after May 1987, you can make a claim regardless of where you currently live. Your case will be evaluated individually, and arrangements can be made for audiological testing in your area if needed.",
    },
    {
        question: 'How long do I have to make a claim?',
        answer: "It's important to submit your claim as soon as you become aware you may be eligible. While there are time limits for bringing claims, early submission helps ensure your case can be processed efficiently and evidence can be gathered while it's still available.",
    },
    {
        question: 'How common is military hearing loss?',
        answer: "Studies indicate that over 14% of personnel returning from overseas deployment suffer from hearing loss. It's estimated that at least 300,000 ex-service personnel in the UK are suffering from hearing loss, and veterans are 3.5 times more likely to experience hearing difficulties than civilians.",
    },
]
